// 国内机票
const domesticRouter = [
  {
    // 航班查询列表页面
    path: '/domesticIndex',
    name: 'domesticIndex',
    component: () => import('@/page/domesticFlight/domesticIndex')
  },
  {
    // 订单填写页面
    path: '/domesticOrderFill',
    name: 'domesticOrderFill',
    component: () => import('@/page/domesticFlight/domesticOrderFill'),
    meta: {
      keepAlive: false
    }
  },
  {
    // 订单确认页面
    path: '/domesticOrderConfirm',
    name: 'domesticOrderConfirm',
    component: () => import('@/page/domesticFlight/domesticOrderConfirm')
  },
  {
    // 预订成功页面
    path: '/bookSuccess',
    name: 'bookSuccess',
    component: () => import('@/page/domesticFlight/bookSuccess')
  }
]

export default domesticRouter



// WEBPACK FOOTER //
// ./src/router/modules/domestic.js